export const appConfig = {
  allowCrawling: true,
  oneSignalAppId: '',
  appBaseUrl: 'https://www.eremmedia.com',
  apiBaseUrl: 'https://be-app.eremnews.com',
  brandName: 'إرم ميديا'
}